module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAQtJREFUSEvlVVEOgjAMbcNF8CTiIdaEL/Uk6kmUL5LuEOJJ5CY1NZgMwnCT4Q/7hLZvr3t9RfjzwT/jwcoArbWFiOwTt/lBRLdPzV5LmfkJAHliwJaINqOA+rGu66SAZVm2LoGViSbx242W67XUWnsSkSIGGBEvxpjGl6PKd/8PVXoHgChAADi6sneBmVnr5ZMqjWE3xUpErt2ITY/FXMDOPJTZ5ywOqDo4OAayLKDS6lh+bykza5DeLvgg4tkYcxkmqGNlWfYG9Yrml7EAgMqnUr0EMx+85h1Ma0bgCr009XrS7rsramht0SoNeM6GiHa+ja8jsQ0oEhyCiJXXvIOrzAhcoUpndCso9QV7vGkdQzjcaQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/contract.png
// module id = PeSG
// module chunks = 3